import { gsap, Power4 } from 'gsap'
import Swiper from 'swiper'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { FreeMode, Navigation } from 'swiper/modules'
import { elementsToMaxHeight } from '../utils/elementsToMaxSizes'
import Lottie from 'lottie-web'

gsap.registerPlugin(ScrollTrigger)

const $body = $('body')

let swiper = new Swiper('.swiper-all-services', {
  modules: [FreeMode, Navigation],
  spaceBetween: 8,
  slidesPerView: 'auto',
  freeMode: {
    enabled: true
  },
  loop: false,
  speed: 1000,
  // autoplay: {
  //     delay: 3500
  // },
  breakpoints: {
    1024: {
      spaceBetween: 16
    }
  },
  navigation: {
    nextEl: '.swiper-all-services-navigation .slide-next',
    prevEl: '.swiper-all-services-navigation .slide-prev'
  }
})

function setupServicesLottie() {

  let serviceIcons = $('.services-lottie-icon')

  if(!serviceIcons.length) { return false }

  let animations = []

  serviceIcons.each(function () {

    let path = $(this).data('src')

    let animation = Lottie.loadAnimation({
      container: this,
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: path
    })

    animations.push(animation)
  })

  $body.on('mouseenter', '.services-card', function () {
    let id = $(this).data('id')
    if(animations[id]) animations[id].play()
  })

  $body.on('mouseleave', '.services-card', function () {
    let id = $(this).data('id')
    if(animations[id]) animations[id].pause()
  })

}

setupServicesLottie()

$(window).on('load', function () {
  elementsToMaxHeight($('.services-card-content'))

  let $allServicesSlider = $('.block-all-services')
  if($allServicesSlider.length) {

    gsap.set('.services-card', { x: '10vw' })

    ScrollTrigger.create({
      trigger: '.block-all-services',
      start: 'top bottom-=10%',
      end: 'center center',
      scrub: true,
      //markers: true,
      once: true,
      onEnter: () => {
        gsap.to('.services-card', {x: 0, delay: 0.1, duration: 0.60, stagger: 0.10, ease: Power4.easeOut})
      }
    })

  }
})
